import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { handleAPIError } from '../../errors';
import { errorMessage } from './constants';

/**
 * Create an user saved project
 * @param {String} projectId
 * @param {String} variationId
 * @param {String} briefId
 * @param {String} brandName
 * @param {String} slogan
 * @returns {Promise<{ id: Number }>}
 */
const createUserSavedProject = async ({ projectId, variationId, briefId, brandName, slogan }) => {
    const requestUrl = pathfinder('logo_maker_makers_create_user_saved_project');

    const data = {
        projectId,
        variationId,
        briefId,
        brandName,
        slogan,
    };

    try {
        const { data: response } = await axios.post(requestUrl, data);
        return response.data.id;
    } catch (response) {
        handleAPIError(response, errorMessage);
    }
};

export default createUserSavedProject;
